function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotIndicatorUnfilled = function SvgDotIndicatorUnfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 15.5c3 0 5.5-2.5 5.5-5.5S13 4.5 10 4.5 4.5 7 4.5 10 7 15.5 10 15.5zm0 2c4.1 0 7.5-3.4 7.5-7.5S14.1 2.5 10 2.5 2.5 5.9 2.5 10s3.4 7.5 7.5 7.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgDotIndicatorUnfilled;